import React, { useState, useEffect, useRef } from 'react';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';

import { styled } from '@mui/material/styles';
import '../zo-hub-input/zo_hub_input.scss';
import './zo-hub-input-textarea.scss';

interface InputHubTextAreaProps {
  title?: string;

  required?: boolean;

  disabled?: boolean;

  placeholder?: string;

  value?: string | any;

  minRows?: number;

  maxRows?: number;

  ref?: any;

  // onBlur: (val: string) => void;
  onBlur?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => any;

  focusInput?: boolean;

  onFocus?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => any;

  inputTextAreaStyle?: React.CSSProperties;

  containerStyles?: React.CSSProperties;

  inputFieldProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;

  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 100%;
    font-size: 16px;
    min-height: 36px;
    padding: 8px;
    color: #000000;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    resize: vertical;
        
     &::placeholder {
      color: #BFC0C2;
      opacity: 1;
      fontSize: 14px;
      fontFamily: Segoe-UI-VF;
      fontWeight: 400;
    }
    &:hover {
      border-color: #000000;
    }
    &:focus {
      border-color: #33A7E8;
    }
    &:focus-visible {
      outline: 0;
    }
  `
);

export const ZoHubInputTextArea = ({
  title,
  placeholder = '',
  value,
  minRows,
  maxRows,
  ref,
  onBlur,
  focusInput = false,
  required = false,
  disabled = false,
  onFocus,
  inputTextAreaStyle,
  containerStyles,
  inputFieldProps,
  onChange = () => {},
}: InputHubTextAreaProps) => {
  if (!ref) {
    ref = useRef<HTMLInputElement>(null);
  }
  const [val, setVal] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (focusInput) {
      ref?.current?.focus();
    } else {
      ref?.current?.blur();
    }
  }, [focusInput]);

  useEffect(() => {
    setVal(value);
  }, [value]);

  // const styleContainer = {
  //   height: '84px',
  //   ...inputTextAreaStyle,
  // };
  return (
    <div className="input_text_area font-regular" style={containerStyles}>
      {title && (
        <span
          className={`input_text_area__title ${isFocused ? 'input_text_area__focused' : ''}`}
        >
          {title}
          {required && <span className="input_text__asterisk">*</span>}
        </span>
      )}
      <Textarea
        className="font-regular"
        // style={styleContainer}
        style={{
          ...inputTextAreaStyle,
        }}
        value={val}
        required={required}
        disabled={disabled}
        minRows={minRows}
        maxRows={maxRows}
        onFocus={(e) => {
          setIsFocused(true);
          onFocus && onFocus(e);
        }}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur && onBlur(e);
        }}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
        {...inputFieldProps}
      />
    </div>
  );
};
